import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-edit-registro',
    templateUrl: './edit-registro.component.html',
    styleUrls: ['./edit-registro.component.css'],
    standalone: false
})
export class EditRegistroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
